import React from 'react';
import ReactDOM from 'react-dom';

import './assets/css/style.css';
import './assets/css/custom.css';
import './assets/css/ck5.css';
import './assets/css/global.scss';
import './assets/css/podcast_custom.css';
import './assets/css/notification_custom.css';
import './assets/css/notes_custom.css';

import reportWebVitals from './reportWebVitals';

import App from './App';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
